// copy link to clipboard function
document.addEventListener('DOMContentLoaded', (event) => {
  const shareNotification = document.querySelector('.share-bar-notification');
  const postLink = document.querySelector('.share-bar .postlink a');
  if( postLink ) {
    postLink.addEventListener('click', (e) => {
      e.preventDefault();
      const str = postLink.getAttribute('href');
      copyToClipBoard(str);
      showHideNotification();
    });

    function copyToClipBoard(str) {
      if (navigator && navigator.clipboard && navigator.clipboard.writeText)
        return navigator.clipboard.writeText(str);
      return Promise.reject('The Clipboard API is not available.'); 
    }

    function showHideNotification() {
      shareNotification.classList.add('show');

      setTimeout( function() {
        shareNotification.classList.remove('show');
      }, 2000);
    }

  }
});